import { render, staticRenderFns } from "./ProjectGroupsList.vue?vue&type=template&id=331a03b8&scoped=true"
import script from "./ProjectGroupsList.vue?vue&type=script&lang=js"
export * from "./ProjectGroupsList.vue?vue&type=script&lang=js"
import style0 from "./ProjectGroupsList.vue?vue&type=style&index=0&id=331a03b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331a03b8",
  null
  
)

export default component.exports